if (!customElements.get('l4-price-toggle')) {
  const storageKey = 'l4:pricingFormat';
  const persistCookie = (format) => {
    document.cookie = `pricingFormat=${format}; Max-Age=31536000; Path=/; SameSite=Lax`;
  };
  // Restore before the VAT app initializes, so prices and labels use the same choice.
  try {
    const savedFormat = localStorage.getItem(storageKey);
    if (savedFormat === 'b2b' || savedFormat === 'b2c') persistCookie(savedFormat);
  } catch (_) {
    // The app cookie still works when browser storage is unavailable.
  }

  customElements.define('l4-price-toggle', class extends HTMLElement {
    connectedCallback() {
      this.sync = (requestedFormat) => {
        const appHost = this.querySelector('.vat-switcher-inline');
        this.classList.toggle('l4-price-toggle--ready',
          typeof window.toggleSwitch === 'function' &&
          !!appHost.querySelector('.t-selector-option') && appHost.style.display !== 'none');
        const cookie = document.cookie.match(/(?:^|;\s*)pricingFormat=([^;]*)/);
        const priceFormat = document.querySelector('.dualPrice[data-pricing]')?.dataset.pricing;
        const format = requestedFormat === 'b2b' || requestedFormat === 'b2c' ? requestedFormat :
          (priceFormat || this.selectedFormat || (cookie ? decodeURIComponent(cookie[1]) :
            (typeof window.readThemeSettings === 'function' ? window.readThemeSettings().defaultPricing : undefined)));
        this.selectedFormat = format;
        if (format === 'b2b' || format === 'b2c') {
          this.querySelector('.l4-price-toggle__options').dataset.selectedFormat = format;
        }

        this.querySelectorAll('[data-price-format]').forEach((button) => {
          const pressed = String(button.dataset.priceFormat === format);
          if (button.getAttribute('aria-pressed') !== pressed) {
            button.setAttribute('aria-pressed', pressed);
          }
        });
      };

      this.onClick = (event) => {
        const button = event.target.closest('[data-price-format]');
        if (!button || button.getAttribute('aria-pressed') === 'true') return;
        // Keep the VAT app's price conversion, cookies and other widgets in sync.
        if (typeof window.toggleSwitch === 'function') {
          const format = button.dataset.priceFormat;
          window.toggleSwitch(format === 'b2c');
          persistCookie(format);
          try {
            localStorage.setItem(storageKey, format);
          } catch (_) {
            // Keep price switching available if browser storage is unavailable.
          }
          // Pages without prices still need their VAT and shipping labels updated.
          if (typeof window.updateAllVatTexts === 'function') window.updateAllVatTexts();
          if (typeof window.updateShippingCosts === 'function') window.updateShippingCosts();
          document.querySelectorAll('l4-price-toggle').forEach((toggle) => toggle.sync?.(button.dataset.priceFormat));
        }
      };

      this.addEventListener('click', this.onClick);
      this.observer = new MutationObserver(this.sync);
      this.observer.observe(this.querySelector('.vat-switcher-inline'), {
        subtree: true,
        childList: true,
        attributes: true
      });
      // The app can update prices without changing the hidden dropdown or cookie.
      this.priceObserver = new MutationObserver(() => this.sync());
      this.priceObserver.observe(document.documentElement, {
        subtree: true,
        attributes: true,
        attributeFilter: ['data-pricing']
      });
      this.sync();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.observer.disconnect();
      this.priceObserver.disconnect();
    }
  });
}
